var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-table',{attrs:{"fields":_vm.fields,"items":_vm.data,"sort-by":"nome"},scopedSlots:_vm._u([{key:"cell(actions)",fn:function({ item }){return [_c('rkm-button',{attrs:{"color":"info","small":"","title":"Observação"},on:{"click":function($event){return _vm.handleOpenModal(item)}}},[_c('rkm-icon',{attrs:{"icon":"info-circle"}})],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }